import {
  GET_PRODUCTS,
  ADD_PRODUCT,
  DELETE_PRODUCT,
  UPDATE_PRODUCT,
  FILTER_PRODUCTS,
  CLEAR_PRODUCT_FILTER,
  SET_CURRENT_PRODUCT,
  CLEAR_CURRENT_PRODUCT,
  PRODUCT_ERROR,
  // CLEAR_PRODUCTS // for nav bar,
} from "../types";

const ProductReducer = (state, action) => {
  switch (action.type) {
    case GET_PRODUCTS:
      return {
        ...state,
        products: action.payload,
        loading: false,
      };

    case ADD_PRODUCT:
      return {
        ...state,
        products: [action.payload, ...state.products],
        loading: false,
      };

    case DELETE_PRODUCT:
      return {
        ...state,
        products: state.products.filter(
          (product) => product._id !== action.payload
        ),
        loading: false,
      };

    case UPDATE_PRODUCT:
      return {
        ...state,
        products: [
          ...state.products.map((product) =>
            product._id === action.payload._id ? action.payload : product
          ),
        ],
        loading: false,
      };

    case FILTER_PRODUCTS:
      return {
        ...state,
        loading: false,
        filtered: state.products.filter((product) => {
          const regex = new RegExp(`${action.payload}`, "gi");
          return product.product_id.match(regex);
        }),
      };

    case CLEAR_PRODUCT_FILTER:
      return { ...state, filtered: null };

    case SET_CURRENT_PRODUCT:
      return { ...state, current: action.payload };

    case CLEAR_CURRENT_PRODUCT:
      return { ...state, current: null };

    case PRODUCT_ERROR:
      return { ...state, error: action.payload };

    default:
      return state;
  }
};

export default ProductReducer;